const THREE = require('three')
import listener from './listener'
import {loadingManager, load, registerSize} from './loader'
import {TweenMax, Cubic} from 'gsap'


export const data = {
  text: {
    url: require('src/assets/sounds/fx/text.mp3'),
    size: 130713,
    volume: 1
  },
  // emoji: {
  //   url: require('src/assets/sounds/fx/emoji.mp3'),
  //   size: 130713,
  //   volume: 2
  // },
  heartbeat: {
    url: require('src/assets/sounds/fx/heartbeat.mp3'),
    size: 130713,
    volume: 2.5
  },
  countdown: {
    url: require('src/assets/sounds/fx/countdown/countdown2.mp3'),
    size: 130713,
    volume: 1
  },
  crowd_start: {
    url: require('src/assets/sounds/fx/crowd/crowd_start.mp3'),
    size: 88727,
    volume: 1,
    loop: true
  },
  crowd_finish: {
    url: require('src/assets/sounds/fx/crowd/crowd_finish.mp3'),
    size: 166679,
    volume: 1
  },
  sonic_boom: {
    url: require('src/assets/sounds/fx/transition/transition2.mp3'),
    size: 130713,
    volume: 2.0
  },
  stepL0: {
    url: require('src/assets/sounds/fx/steps/stepL1.mp3'),
    size: 10000,
    volume: 1.5
  },
  stepL1: {
    url: require('src/assets/sounds/fx/steps/stepL2.mp3'),
    size: 10000,
    volume: 1.5
  },
  stepL2: {
    url: require('src/assets/sounds/fx/steps/stepL3.mp3'),
    size: 10000,
    volume: 1.5
  },
  stepR0: {
    url: require('src/assets/sounds/fx/steps/stepR1.mp3'),
    size: 10000,
    volume: 1.5
  },
  stepR1: {
    url: require('src/assets/sounds/fx/steps/stepR2.mp3'),
    size: 10000,
    volume: 1.5
  },
  stepR2: {
    url: require('src/assets/sounds/fx/steps/stepR3.mp3'),
    size: 10000,
    volume: 1.5
  },
  breath0: {
    url: require('src/assets/sounds/fx/breathing/breathing1.mp3'),
    size: 10000,
    volume: 3.5
  },
  breath1: {
    url: require('src/assets/sounds/fx/breathing/breathing3.mp3'),
    size: 10000,
    volume: 3.5
  },
  breath2: {
    url: require('src/assets/sounds/fx/breathing/breathing4.mp3'),
    size: 10000,
    volume: 3.5
  },
  breath3: {
    url: require('src/assets/sounds/fx/breathing/breathing5.mp3'),
    size: 10000,
    volume: 3.5
  },
  breath4: {
    url: require('src/assets/sounds/fx/breathing/breathing6.mp3'),
    size: 10000,
    volume: 3.5
  }
}
export default data



// CREATE AUDIO
let loader = new THREE.AudioLoader(loadingManager)
for (let key in data) {
  let _data = data[key]

  // CREATE AUDIO OBJECT
  if (_data.positional === true) {
    _data.audio = new THREE.PositionalAudio(listener)
    _data.audio.setRefDistance(_data.distance || 1)
  } else {
    _data.audio = new THREE.Audio(listener)
  }

  // LOAD
  registerSize(_data.url, _data.size)

}



// LOAD
export let loaded = false
export let checkAllLoaded = function () {
  for (let key in data) {
    let _data = data[key]
    if (!_data.buffer) return false
  }
  loaded = true
  return true
}
export const loadAll = function () {
  for (let key in data) {
    // console.log(key)
    let _data = data[key]
    load(_data.url, null, (results)=> {
      _data.buffer = results[0]
      _data.audio.setBuffer(results[0])
      _data.audio.setLoop(_data.loop || false)

      // PRE PLAY ONCE
      _data.audio.setVolume(0.001)
      _data.audio.play()
      _data.audio.stop()
      _data.audio.setVolume(_data.volume || 1)
      checkAllLoaded()
    })
  }
}

loadAll()


// FADE TO METHOD
const fadeTo = function (to, time = 1) {
  let _audio = this
  TweenMax.to({volume: this.getVolume()}, time, {
    volume: to,
    ease: Cubic.easeIn,
    onStart: ()=> {
      if (_audio.getVolume() === 0) {
        _audio.stop()
        _audio.play()
      }
    },
    onUpdateParams: ['{self}'],
    onUpdate: (tween)=> {
      const volume = tween.target.volume
      _audio.setVolume(volume)
    },
    onComplete: ()=> {
      // if (_audio.getVolume() === 0) {
      //   _audio.stop()
      // }
    }
  })
}

THREE.Audio.prototype.fadeTo = fadeTo
THREE.PositionalAudio.prototype.fadeTo = fadeTo


// PLAY PROMISE METHOD
THREE.Audio.prototype.playPromise = function () {
  return new Promise((resolve)=> {
    this.onEnded = function () {
      this.isPlaying = false
      this.onEnded = function () {
        this.isPlaying = false
      }
      resolve()
    }
    this.play()
  })
}


// export const getAudio = function(id) {
//   let audio = new THREE.Audio(listener)
//   audio.setBuffer(data[id].buffer)
//   return audio
// }

// export const getPositionalAudio = function(id) {
//   let audio = new THREE.PositionalAudio(listener)
//   audio.setBuffer(data[id].buffer)
//   return audio
// }






// WEBPACK FOOTER //
// ./src/components/game/sounds.js